module.exports = __webpack_public_path__ + "img/ASO_fr15.11825471.png";